import { IProduct } from "src/core/products/api/products.api";
import useAxios from "src/core/shared/hooks/useAxios";
import {
  RequestConfig,
  UseApiRequest,
  EndpointConfig
} from "src/core/shared/api/config.api";

export type CreateUpdateFeaturedProduct = Omit<IFeaturedProduct, "id"> & Partial<Pick<IFeaturedProduct, "id">>;
export type BulkUpdateFeaturedProductsParams = { data: CreateUpdateFeaturedProduct[] };
export type GetFeaturedProductsByBranch = { branchId: number };

export interface IFeaturedProduct {
  id: number;
  productId: number;
  startDate: Date | string;
  endDate?: Date | string | null;
  priority: number;
  product?: IProduct;
}

export enum FeaturedProductsRequestName {
  GET_FEATURED_PRODUCTS = "GET_FEATURED_PRODUCTS",
  BULK_UPDATE_FEATURED_PRODUCTS = "BULK_UPDATE_FEATURED_PRODUCTS",
}

type FeaturedProductsEndpointConfig = {
  [FeaturedProductsRequestName.GET_FEATURED_PRODUCTS]: EndpointConfig<
    null,
    IFeaturedProduct[]
  >,
  [FeaturedProductsRequestName.BULK_UPDATE_FEATURED_PRODUCTS]: EndpointConfig<
    BulkUpdateFeaturedProductsParams,
    IFeaturedProduct[]
  >
};

const BASE_URL = `${process.env.REACT_APP_API_URL}/promotion/featured-products`;

/**
 * featured products API
 */
const requests: RequestConfig<FeaturedProductsEndpointConfig> = {
  [ FeaturedProductsRequestName.GET_FEATURED_PRODUCTS ]: () => ({
    url: `${BASE_URL}/all`,
    method: "GET"
  }),
  [ FeaturedProductsRequestName.BULK_UPDATE_FEATURED_PRODUCTS ]: ({ data }) => ({
    url: `${BASE_URL}/save`,
    method: "PATCH",
    data
  })
};

export const useFeaturedProductsApi: UseApiRequest<FeaturedProductsEndpointConfig> = name => useAxios(requests[ name ], name);
